<template>
  <div class="cdkey-container">
    <!-- 添加 Toast 组件 -->
    <ToastNotification
      v-if="showToast"
      v-bind="toastConfig"
      @close="showToast = false"
    />
    <!-- 导航栏 -->
    <div class="nav-tabs">
      <button
        :class="['nav-tab', { active: currentView === 'list' }]"
        @click="currentView = 'list'"
      >
        领取 Kick 奖励
      </button>
      <button
        :class="['nav-tab', { active: currentView === 'query' }]"
        @click="currentView = 'query'"
      >
        查询奖励码
      </button>
    </div>

    <!-- 兑换部分 -->
    <template v-if="currentView === 'list'">
      <!-- 游戏列表视图 -->
      <div v-if="!selectedGame" class="game-list">
        <div
          v-for="game in games"
          :key="game.id"
          class="game-card"
          @click="selectGame(game)"
        >
          <img :src="game.image" :alt="game.title" class="game-image" />
          <div class="game-info">
            <h3>{{ game.title }}</h3>
            <div class="game-stats">
              <span>Kick 奖励领取</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Kick奖励兑换表单 -->
      <div v-else class="redeem-form">
        <div class="back-button" @click="selectedGame = null">
          <i class="fas fa-arrow-left"></i>
          <span>返回游戏列表</span>
        </div>

        <div v-if="!gameConfig">
          <p class="error-message">该游戏暂未配置Kick奖励功能</p>
        </div>

        <template v-else>
          <!-- 添加游戏标题 -->
          <div class="game-title">
            <img
              :src="selectedGame.image"
              :alt="selectedGame.title"
              class="game-title-image"
            />
            <h2 class="game-title-text">{{ selectedGame.title }}</h2>
          </div>

          <!-- 登录方式选择 -->
          <div class="login-methods" v-if="gameConfig.loginMethods.length > 1">
            <div class="form-group">
              <label>登录方式</label>
              <div class="login-method-buttons">
                <button
                  v-for="method in gameConfig.loginMethods"
                  :key="method.id"
                  :class="[
                    'method-btn',
                    { active: selectedLoginMethod === method.id },
                  ]"
                  @click="selectLoginMethod(method.id)"
                >
                  {{ method.name }}
                </button>
              </div>
            </div>
          </div>

          <!-- 动态表单 -->
          <form
            v-if="currentLoginMethod"
            @submit.prevent="handleSubmit"
            class="form-content"
          >
            <template v-for="field in currentFields" :key="field.name">
              <div class="form-group">
                <label>{{ field.label }}</label>
                <!-- Kick奖励码输入框 - 根据URL参数决定是否禁用 -->
                <input
                  v-if="field.name === 'reward_code'"
                  :type="field.type"
                  v-model="formData[field.name]"
                  :placeholder="field.placeholder"
                  :required="field.required"
                  :disabled="rewardCodeFromUrl"
                  :class="{ 'input-disabled': rewardCodeFromUrl }"
                />
                <!-- 普通输入框 -->
                <input
                  v-else
                  :type="field.type"
                  v-model="formData[field.name]"
                  :placeholder="field.placeholder"
                  :required="field.required"
                />
              </div>
            </template>

            <button
              type="submit"
              class="submit-btn"
              :disabled="isButtonDisabled"
              :class="{ loading: isSubmitting || isLoading }"
            >
              <span class="btn-content">
                <span class="spinner" v-if="isSubmitting || isLoading"></span>
                <span class="btn-text">{{ submitButtonText }}</span>
              </span>
            </button>
          </form>
        </template>
      </div>
    </template>

    <!-- 查询部分 -->
    <div v-if="currentView === 'query'" class="redeem-form">
      <form @submit.prevent="handleQuery" class="form-content">
        <div class="form-group">
          <label>Kick奖励码</label>
          <input
            type="text"
            v-model="queryData.reward_code"
            placeholder="请输入要查询的Kick奖励码"
            required
          />
        </div>

        <button
          type="submit"
          class="submit-btn"
          :disabled="isQueryLoading"
          :class="{ loading: isQueryLoading }"
        >
          <span class="btn-content">
            <span class="spinner" v-if="isQueryLoading"></span>
            <span class="btn-text">{{
              isQueryLoading ? "查询中..." : "查询"
            }}</span>
          </span>
        </button>
      </form>

      <!-- 查询结果 -->
      <div v-if="queryResult" class="query-result">
        <div class="result-item">
          <label>奖励码状态：</label>
          <span
            :class="[
              'status',
              queryResult.status === 'unused' ? 'status-unused' : 'status-used',
            ]"
          >
            {{ queryResult.status === "unused" ? "未使用" : "已使用" }}
          </span>
        </div>
        <div class="result-item">
          <label>游戏名称：</label>
          <span>{{ queryResult.game }}</span>
        </div>
        <div v-if="queryResult.status === 'used'" class="result-item">
          <label>使用时间：</label>
          <span>{{ queryResult.usedTime }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToastNotification from "@/components/common/ToastNotification.vue";
import { KICK_GAME_CONFIGS } from "@/config/kickGames";

export default {
  name: "KickRewards",
  data() {
    return {
      currentView: "list",
      selectedGame: null,
      games: [
        {
          id: "rust",
          title: "Rust",
          image: "/cdk/rust.jpg",
        },
        // {
        //   id: "pubg",
        //   en_title: "PUBG: BATTLEGROUNDS",
        //   title: "PUBG: BATTLEGROUNDS",
        //   image: "/cdk/pubg.png",
        // },
      ],
      formData: {
        username: "",
        password: "",
        reward_code: "",
      },
      queryData: {
        reward_code: "",
      },
      queryResult: null,
      showToast: false,
      toastConfig: {
        type: "success",
        title: "",
        message: "",
        duration: 3000,
      },
      isLoading: false,
      isQueryLoading: false,
      selectedLoginMethod: null,
      requiredExtraFields: [],
      verificationStep: "initial",
      hasExtraFields: false,
      isSubmitting: false,
      rewardCodeFromUrl: false,
    };
  },
  components: {
    ToastNotification,
  },
  methods: {
    showNotification(config) {
      this.toastConfig = {
        type: "info",
        title: "",
        message: "",
        duration: 3000,
        autoClose: true,
      };
      this.toastConfig = { ...this.toastConfig, ...config };
      this.showToast = true;
    },

    selectGame(game) {
      this.selectedGame = game;
      this.formData = {};

      if (this.$route.query.code) {
        this.formData.reward_code = this.$route.query.code;
        this.rewardCodeFromUrl = true;
      }

      if (this.gameConfig?.loginMethods?.length > 0) {
        this.selectedLoginMethod = this.gameConfig.loginMethods[0].id;
      } else {
        this.selectedLoginMethod = null;
      }
    },

    selectLoginMethod(methodId) {
      this.selectedLoginMethod = methodId;
      this.formData = {};

      if (this.$route.query.code) {
        this.formData.reward_code = this.$route.query.code;
        this.rewardCodeFromUrl = true;
      }
    },

    processUrlParams() {
      const { code, game } = this.$route.query;

      if (code) {
        this.formData.reward_code = code;
        this.rewardCodeFromUrl = true;
      }

      if (game) {
        const gameObj = this.games.find(
          (g) => g.id.toLowerCase() === game.toLowerCase()
        );
        if (gameObj) {
          this.selectGame(gameObj);
        }
      }
    },

    validateForm() {
      const method = this.currentLoginMethod;
      if (!method) return false;

      for (const field of this.currentLoginMethod.fields) {
        if (field.required && !this.formData[field.name]) {
          this.showNotification({
            type: "error",
            title: "表单错误",
            message: `请填写${field.label}`,
          });
          return false;
        }
      }

      if (this.hasExtraFields) {
        for (const fieldName of this.requiredExtraFields) {
          const extraField = this.currentLoginMethod.extraFields[fieldName];
          if (extraField?.required && !this.formData[fieldName]) {
            this.showNotification({
              type: "error",
              title: "表单错误",
              message: `请填写${extraField.label}`,
            });
            return false;
          }
        }
      }

      return true;
    },

    async handleQuery() {
      if (!this.queryData.reward_code) {
        this.showNotification({
          type: "error",
          title: "查询错误",
          message: "请输入Kick奖励码",
        });
        return;
      }

      try {
        this.isQueryLoading = true;

        const queryUrl = `/api/bindings/kick/cdk?cdk=${encodeURIComponent(
          this.queryData.reward_code
        )}`;

        const response = await fetch(queryUrl);
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || "查询失败");
        }

        if (data.success) {
          this.queryResult = {
            status: data.data?.status === 1 ? "used" : "unused",
            game: data.data?.game_id || "",
            usedTime: data.data?.used_at || "Unknown",
          };

          this.showNotification({
            type: "info",
            title: "查询结果",
            message: data.message || `奖励码状态：${this.queryResult.status === "unused" ? "未使用" : "已使用"}`,
            duration: 5000,
          });
        } else {
          throw new Error(data.message || "查询失败");
        }
      } catch (error) {
        this.showNotification({
          type: "error",
          title: "查询失败",
          message: error.message || "请稍后重试",
          duration: 5000,
        });
      } finally {
        this.isQueryLoading = false;
      }
    },

    async verifyCredentials() {
      const method = this.currentLoginMethod;
      if (!method?.verify) return true;

      try {
        this.verificationStep = "verifying";
        this.isLoading = true;

        const { api, transformData } = method.verify;
        const verifyData = transformData(this.formData);

        const response = await fetch(api, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(verifyData),
        });

        const result = await response.json();

        if (!response.ok) {
          if (response.status === 403 && result.required_fields?.length > 0) {
            this.requiredExtraFields = result.required_fields;
            this.hasExtraFields = true;
            this.verificationStep = "needExtra";
            this.showNotification({
              type: "info",
              title: "需要验证",
              message: result.message || "请完成额外验证",
              duration: 5000,
            });
            return true;
          }
          throw new Error(result.message || "验证失败");
        }

        this.verificationStep = "verified";
        return true;
      } catch (error) {
        this.showNotification({
          type: "error",
          title: "验证失败",
          message: error.message || "请检查账号密码是否正确",
          duration: 5000,
        });
        this.verificationStep = "initial";
        return false;
      } finally {
        this.isLoading = false;
      }
    },

    async handleSubmit() {
      if (
        this.currentLoginMethod?.verify &&
        this.verificationStep === "initial"
      ) {
        const verified = await this.verifyCredentials();
        if (!verified) return;
        if (this.hasExtraFields) return;
      }

      if (!this.validateForm()) {
        return;
      }

      try {
        this.isSubmitting = true;

        const { api, transformData } = this.currentLoginMethod.submit;
        const submitData = transformData(this.formData);

        const response = await fetch(api, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(submitData),
        });

        const result = await response.json();

        if (this.verificationStep == "verified" || result.success) {
          const claimResult = await this.rewardClaim();
          if (claimResult.success) {
            this.showNotification({
              type: "success",
              title: "领取成功",
              duration: 10000,
              autoClose: false,
              message: claimResult.message || result.message || `${this.selectedGame.title} Kick奖励已成功领取！`,
            });
          } else {
            this.showNotification({
              type: "error",
              title: "领取失败",
              duration: 10000,
              autoClose: true,
              message: claimResult.message || result.message || `${this.selectedGame.title} Kick奖励领取失败！`,
            });
          }

          this.resetForm();
        } else {
          this.showNotification({
            type: "info",
            title: "验证失败",
            message: result.message || "验证失败！请使用稳定网络！",
          });
        }
      } catch (error) {
        this.showNotification({
          type: "error",
          title: "领取失败",
          message: error.message || "请稍后重试",
          duration: 5000,
        });

        if (error instanceof TypeError && error.message === "Failed to fetch") {
          this.showNotification({
            type: "error",
            title: "网络错误",
            message: "请检查网络连接后重试",
            duration: 5000,
          });
        }
      } finally {
        this.isSubmitting = false;
      }
    },

    resetForm() {
      this.formData = {};
      this.verificationStep = "initial";
      this.hasExtraFields = false;
      this.requiredExtraFields = [];
      this.isSubmitting = false;
      this.isLoading = false;

      if (this.$route.query.code) {
        this.formData.reward_code = this.$route.query.code;
        this.rewardCodeFromUrl = true;
      } else {
        this.rewardCodeFromUrl = false;
      }
    },

    async rewardClaim() {
      const { api, transformData } = this.currentLoginMethod.claim;
      const submitData = transformData(this.formData);

      this.showNotification({
        type: "info",
        title: "领取提示",
        message: "正在领取奖励，请耐心等待!",
        duration: 3000,
        autoClose: false,
      });

      const responseClaim = await fetch(api, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(submitData),
      });

      const result = await responseClaim.json();
      return result;
    },
  },
  computed: {
    gameConfig() {
      return this.selectedGame ? KICK_GAME_CONFIGS[this.selectedGame.title] : null;
    },

    currentLoginMethod() {
      if (!this.gameConfig?.loginMethods) return null;
      return (
        this.gameConfig.loginMethods.find(
          (method) => method.id === this.selectedLoginMethod
        ) || this.gameConfig.loginMethods[0]
      );
    },

    currentFields() {
      if (!this.currentLoginMethod) return [];

      const baseFields = [...this.currentLoginMethod.fields];

      if (
        this.currentLoginMethod.extraFields &&
        this.requiredExtraFields.length > 0
      ) {
        this.requiredExtraFields.forEach((fieldName) => {
          const extraField = this.currentLoginMethod.extraFields[fieldName];
          if (extraField) {
            baseFields.push(extraField);
          }
        });
      }

      return baseFields;
    },

    submitButtonText() {
      if (this.isSubmitting) return "领取中...";
      if (this.verificationStep === "verifying") return "验证中...";
      return "领取奖励";
    },

    isButtonDisabled() {
      return (
        this.isSubmitting ||
        this.isLoading ||
        this.verificationStep === "verifying"
      );
    },
  },
  mounted() {
    this.processUrlParams();
  },
  watch: {
    "$route.query": {
      handler() {
        this.processUrlParams();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
/* 使用与 ClaimCdk.vue 相同的样式 */
.cdkey-container {
  padding: 24px;
  min-height: 100vh;
  background-color: #1a1b26;
  color: #e5e7eb;
}

.game-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.game-card {
  background-color: rgba(36, 39, 58, 0.8);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(10px);
}

.game-card:hover {
  transform: translateY(-4px);
  border-color: rgba(59, 130, 246, 0.5);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
}

.game-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.game-card:hover .game-image {
  transform: scale(1.05);
}

.game-info {
  padding: 20px;
  background: linear-gradient(
      to bottom,
      rgba(36, 39, 58, 0.8),
      rgba(36, 39, 58, 0.95)
  );
}

.game-stats {
  display: flex;
  gap: 16px;
  color: #9ca3af;
  font-size: 14px;
}

.redeem-form {
  max-width: 480px;
  margin: 0 auto;
  background-color: rgba(36, 39, 58, 0.9);
  border-radius: 16px;
  padding: 32px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.back-button {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #e5e7eb;
  cursor: pointer;
  margin-bottom: 24px;
  background-color: rgba(55, 65, 81, 0.5);
  padding: 12px 20px;
  border-radius: 8px;
  border: 1px solid rgba(75, 85, 99, 0.4);
  font-weight: 500;
  transition: all 0.2s ease-in-out;
  width: fit-content;
}

.back-button i {
  font-size: 1.1em;
  transition: transform 0.2s ease-in-out;
}

.back-button:hover {
  color: #ffffff;
  background-color: rgba(59, 130, 246, 0.15);
  border-color: rgba(59, 130, 246, 0.5);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.back-button:hover i {
  transform: translateX(-4px);
}

.back-button:active {
  transform: translateY(1px);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  color: #9ca3af;
  margin-bottom: 8px;
}

.form-group input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  background-color: rgba(31, 41, 55, 0.7);
  color: #ffffff;
  font-size: 15px;
  transition: all 0.3s ease;
}

.form-group input.input-disabled {
  background-color: rgba(31, 41, 55, 0.5);
  border-color: rgba(255, 255, 255, 0.05);
  color: #9ca3af;
  cursor: not-allowed;
}

.form-group input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25);
  background-color: rgba(31, 41, 55, 0.9);
}

.submit-btn {
  width: 100%;
  padding: 12px;
  background-color: #3b82f6;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.2s;
  position: relative;
  overflow: hidden;
}

.submit-btn:hover {
  background-color: #2563eb;
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading .btn-text {
  opacity: 0.8;
}

.nav-tabs {
  display: flex;
  gap: 16px;
  max-width: 1200px;
  margin: 0 auto 24px;
}

.nav-tab {
  padding: 12px 32px;
  background-color: rgba(36, 39, 58, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: #9ca3af;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.nav-tab.active {
  background-color: #3b82f6;
  border-color: rgba(59, 130, 246, 0.5);
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
}

.nav-tab:hover {
  color: #ffffff;
}

.nav-tab:hover:not(.active) {
  background-color: rgba(36, 39, 58, 0.95);
  border-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

.query-result {
  margin-top: 24px;
  border-top: 1px solid #374151;
  padding-top: 24px;
}

.result-item {
  margin-bottom: 16px;
  color: #9ca3af;
}

.result-item label {
  color: #ffffff;
  margin-right: 8px;
}

.status {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
}

.status-used {
  background-color: #991b1b;
  color: #fecaca;
}

.status-unused {
  background-color: #065f46;
  color: #a7f3d0;
}

.login-methods {
  margin-bottom: 24px;
}

.login-method-buttons {
  display: flex;
  gap: 12px;
  margin-top: 8px;
}

.method-btn {
  padding: 8px 16px;
  background-color: #1f2937;
  border: 1px solid #374151;
  border-radius: 4px;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s;
}

.method-btn.active {
  background-color: #3b82f6;
  border-color: #3b82f6;
  color: #ffffff;
}

.game-title {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #374151;
}

.game-title-image {
  width: 64px;
  height: 64px;
  border-radius: 8px;
  object-fit: cover;
}

.game-title-text {
  color: #ffffff;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
}

.error-message {
  color: #ef4444;
  text-align: center;
  padding: 20px;
}

@media (max-width: 640px) {
  .cdkey-container {
    padding: 16px;
  }

  .game-list {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .nav-tabs {
    flex-direction: column;
    gap: 12px;
  }

  .redeem-form {
    padding: 24px;
    margin: 0 16px;
  }

  .login-method-buttons {
    flex-direction: column;
  }

  .method-btn {
    width: 100%;
    text-align: center;
  }

  .game-title {
    flex-direction: column;
    text-align: center;
  }
}
</style>
